import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { userLogout } from '../../redux/modules/auth';
import { connect } from 'react-redux';
import userImg from '../../img/user.png';
import { uploadImage } from '../../utils/files';
import { businessUserType1, mainApiUrl } from '../../utils/consts';

const select = state => {
  return {
    user: state.auth.user
  };
};

function mapDispatchToProps(dispatch) {
  return {
    userLogout: () => dispatch(userLogout())
  };
}

function ConnectedSidebar(props) {

  const { user } = props;
  const [expanded, setExpanded] = useState(false);

  const updateLogo = async () => {
    const logo = document.getElementById('logoUser').files[0];

    if (logo.size > 20000000) {
      alert('El tamaño máximo de la imágen es de 20mb');
    } else {

      const imageUrl = await uploadImage(logo);

      if (imageUrl) {

        const prom = await fetch(`${mainApiUrl}/users/update`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            _id: user._id,
            logo: imageUrl
          })
        });

        const json = await prom.json();

        if (json.success) props.refresh();
        else alert('Ocurrió un error. Inténtalo nuevamente.');

      } else {
        alert('Hubo un error, inténtalo nuevamente.');
      }
    }
  };

  const { history } = props;
  const isAdmin = user.nibiBusinessRole === 'ADMIN';
  const isUserType1 = props.user && props.user.nibiBusinessUserType === businessUserType1;

  return (
    <div
      id="sideBar"
      className={expanded ? 'active': ''}
      style={{ paddingTop: isAdmin ? '0' : '20px' }}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
    >
      <div className="center">
        <br />
        <div className="image-upload">
          <label htmlFor="logoUser">
            <img
              id="sidebarLogo"
              className={expanded ? 'active': ''}
              src={user.logo || userImg}
            />
          </label>
          <input
            id="logoUser"
            type="file"
            accept="image/*"
            onChange={updateLogo}
          />
        </div>
      </div>
      <div className="sidebarID">
        {`${user.firstName} ${user.lastName}`}
      </div>
      {
        isAdmin ?
        <hr id="sidebarSeparator" style={{ marginBottom: 0, marginTop: '10px' }} /> :
        <hr id="sidebarSeparator" />
      }

      <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/perfil`)}>
        <div>
          <i className="fa fa-id-card-o" aria-hidden="true" style={{ textAlign: 'left' }} />
          <strong> PERFIL</strong>
        </div>
      </button>

      {
        !user.nibiBusinessRelatedUserId &&
        <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/familia`)}>
          <div>
            <i className="fas fa-user-friends" aria-hidden="true" style={{ textAlign: 'left' }} />
            <strong> FAMILIA</strong>
          </div>
        </button>
      }

      <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/productos`)}>
        <div>
          <i className="fas fa-store" aria-hidden="true" />
          <strong> MIS PRODUCTOS</strong>
        </div>
      </button>

      {
        isUserType1 &&
        <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/seccion_solidaria`)}>
          <div>
            <i className="fas fa-people-carry" aria-hidden="true" />
            <strong> MI MURO DE LA SOLIDARIDAD</strong>
          </div>
        </button>
      }

      <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/billetera`)}>
        <div>
          <i className="fas fa-wallet" aria-hidden="true" />
          <strong> BILLETERA</strong>
        </div>
      </button>

      <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/documentos`)}>
        <div>
          <i className="fas fa-file-upload" aria-hidden="true" />
          <strong> DOCUMENTOS</strong>
        </div>
      </button>

      {
        isAdmin &&
        <>
          <hr id="sidebarSeparator" style={{ marginTop: 0, marginBottom: 0 }} />
          <div className="sidebarID">
            Admin
          </div>
          <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/admin/dashboard`)}>
            <div>
              <i className="fas fa-chart-line" aria-hidden="true" />
              <strong> DASHBOARD</strong>
            </div>
          </button>
          <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/admin/usuarios`)}>
            <div>
              <i className="fas fa-users" aria-hidden="true" />
              <strong> USUARIOS</strong>
            </div>
          </button>
          <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/admin/seccion_solidaria`)}>
            <div>
              <i className="fas fa-hand-holding-medical" aria-hidden="true" />
              <strong> MURO DE LA SOLIDARIDAD</strong>
            </div>
          </button>
          <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/admin/productos`)}>
            <div>
              <i className="fas fa-boxes" aria-hidden="true" />
              <strong> PRODUCTOS</strong>
            </div>
          </button>
          <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/admin/desembolsos`)}>
            <div>
              <i className="fas fa-receipt" aria-hidden="true" />
              <strong> DESEMBOLSOS</strong>
            </div>
          </button>
          <button className="sidebarLink buttonNoStyle" onClick={() => history.push(`/dashboard/admin/descuentos_nomina`)}>
            <div>
              <i className="fas fa-money-check" aria-hidden="true" />
              <strong> DESCUENTOS DE NÓMINA</strong>
            </div>
          </button>
        </>
      }
    </div>
  );
}

const Sidebar = connect(select, mapDispatchToProps)(ConnectedSidebar);

export default withRouter(Sidebar);
